import { AccordionWithImage } from "../components/accordion-with-image";
import { AccordionsText } from "../components/accordions-text";
import { AmenitiesList } from "../components/amenities-list";
import { ConditionsTable } from "../components/conditions-table";
import { EventProgramTable } from "../components/event-program-table";
import { Gallery } from "../components/gallery";
import { QuoteWithAuthor } from "../components/quote-with-author";
import { SectionName } from "../components/section-name";
import { Table } from "../components/table";
import { TextBlock } from "../components/text-block";
import { VideoBlock } from "../components/video-block";

export const articleBlockSchema = {
  "article.text-block": TextBlock,
  "article.quote-with-author": QuoteWithAuthor,
  "article.table": Table,
  "article.gallery": Gallery,
  "article.video": VideoBlock,
  "article.section-name": SectionName,
  "article.list-with-icon": AmenitiesList,
  "article.conditions-table": ConditionsTable,
  "event.event-program": EventProgramTable,
  "article.accordions-text": AccordionsText,
  "article.accordion-with-image": AccordionWithImage,
};
